import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { PowerOfAttorneyInfo } from '../../../supplier/modules/offer-item/models/power-attorney-info';

@Component({
  selector: 'app-m2d-documents-offer-dialog',
  templateUrl: './m2d-documents-offer.component.html',
  styleUrls: ['./m2d-documents-offer.component.scss'],
})
export class M2DDocumentsOfferDialogComponent {
  public httpHeaders: HttpHeaders;
  public isMaximizableDisplay = false;
  @Input()
  public powerOfAttorneyInfo: PowerOfAttorneyInfo;
  @Input()
  public showM2DModal: boolean = false;

  @Output()
  public accept = new EventEmitter();
  @Output()
  public close = new EventEmitter();
  @Output()
  public download = new EventEmitter();
  constructor() {
    this.httpHeaders = new HttpHeaders({
      accept: '*/*',
    });
  }

  public onAcceptM2DModal(): void {
    this.accept.emit();
  }

  public onClose(): void {
    this.isMaximizableDisplay = false;
    this.close.emit();
  }

  public onMaximize($event): void {
    this.isMaximizableDisplay = $event.maximized;
  }

  public downloadFile(powerOfAttorneyEisId: string): void {
    this.download.emit(powerOfAttorneyEisId);
  }
}
